// extracted by mini-css-extract-plugin
export default {"social":"styles--social--1Jq-g","share":"styles--share--3qLNp"};